export default "__VITE_ASSET__VfEe2HEL__"